import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = { bytes: number; toFixed?: number; withComma?: boolean };

const BytesToFileSize: FC<Props> = ({ bytes, toFixed, withComma }) => {
  const { t } = useTranslation();

  const commaString = withComma ? ', ' : '';

  if (bytes >= 1024000)
    return <span>{`${(bytes / 1024000).toFixed(toFixed)} ${t('mb')}${commaString}`}</span>;
  return <span>{`${(bytes / 1024).toFixed(toFixed)} ${t('kb')}${commaString}`}</span>;
};

export default BytesToFileSize;
